import React from "react";
import "./DailyRouteCoverSheet.scss";

type Props = {
    dailyRouteName: string;
    routeName: string;
    routeDate: string;
    driverName: string;
    vehicleName: string;
    orderCount: number;
};

export const DailyRouteCoverSheet: React.FC<Props> = ({ dailyRouteName, routeName, routeDate, driverName, vehicleName, orderCount }) => {
    return (
        <div className={"DailyRouteCoverSheet"}>
            <div className={"cover-sheet-content"}>
                {dailyRouteName && <div className={"daily-route-name"}>{dailyRouteName}</div>}

                {routeName && (
                    <div className={"cover-sheet-detail"}>
                        <i className={"fas fa-route me-2"} />
                        {routeName}
                    </div>
                )}

                <div className={"cover-sheet-detail"}>
                    <i className={"fas fa-calendar me-2"} />
                    {routeDate}
                </div>

                {driverName !== "-" && (
                    <div className={"cover-sheet-detail"}>
                        <i className={"fas fa-user me-2"} />
                        {driverName}
                    </div>
                )}

                {vehicleName !== "-" && (
                    <div className={"cover-sheet-detail"}>
                        <i className={"fas fa-truck me-2"} />
                        {vehicleName}
                    </div>
                )}

                <div className={"cover-sheet-order-count mt-4"}>
                    {orderCount} {orderCount === 1 ? "Order" : "Orders"}
                </div>
            </div>
        </div>
    );
};
